import { useState } from 'react';

export type TextDiffLayout = 'split' | 'unified';

export const TEXT_DIFF_LAYOUT_STORAGE_KEY = 'physnaTextDiffLayout';

const getStoredLayout = (): TextDiffLayout =>
  localStorage.getItem(TEXT_DIFF_LAYOUT_STORAGE_KEY) === 'unified' ? 'unified' : 'split';

export const useTextDiffLayout = () => {
  const [layout, setLayout] = useState<TextDiffLayout>(getStoredLayout);

  const saveLayout = (newLayout: TextDiffLayout) => {
    setLayout(newLayout);
    localStorage.setItem(TEXT_DIFF_LAYOUT_STORAGE_KEY, newLayout);
  };

  return { layout, saveLayout };
};
